var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{class:{ longName: _vm.isLongName }},[_c('button',{attrs:{"aria-label":`Gå till kapitlet ${_vm.item.Name}`},on:{"click":function($event){return _vm.showTree(_vm.item)}}},[_c('span',[_vm._v(" "+_vm._s(_vm.item.Name)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }